const SHEET_ID = "1mFe8i3B087YuLU1wN1jrNZolA3W29THRyinRkePWS3Y";
const SHEET_NAME = "Sheet1";

const url =
    `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?` +
        `tqx=out:json&sheet=${encodeURIComponent(SHEET_NAME)}`;

const citySelect = document.getElementById("citySelect");
const clubSelect = document.getElementById("clubSelect");
const resultEl = document.getElementById("clubResult");
const joinBtn = document.getElementById("joinBtn");

let sheetData = [];
let hasShownResultOnce = false;

// Helper Functions
function getText(cell) {
    if (!cell || cell.v === null || cell.v === undefined) return "";
    return String(cell.v).replace(/\s+/g, " ").trim();
}

function safeText(el, value, fallback = "—") {
    el.innerText = value ? value : fallback;
}

function hideResult() {
    if (!hasShownResultOnce) {
        resultEl.classList.remove("is-visible");
        resultEl.hidden = true;
    }
}

function showResult() {
    resultEl.hidden = false;
    hasShownResultOnce = true;
    requestAnimationFrame(() => resultEl.classList.add("is-visible"));
}

function formatIndianPhone(value) {
    if (!value) return "";
    return String(value)
        .split(/[\/,|]/)
        .map((n) => n.trim())
        .filter(Boolean)
        .map((n) => `+91 ${n}`)
        .join(" / ");
}

function formatDescription(text) {
    if (!text) return "";

    text = text.replace(/\s+/g, " ").trim();

    const parts = text.split("•").map(p => p.trim()).filter(Boolean);

    let paragraphs = [];
    let bullets = [];
    let postBulletParagraphs = [];

    parts.forEach((part, index) => {
        // First block: normal paragraphs before bullets
        if (index === 0 && !/^\d/.test(part)) {
            const sentences = part.match(/[^.!?]+[.!?]?/g) || [];
            sentences.forEach(s => {
                const line = s.trim();
                if (line) paragraphs.push(line);
            });
            return;
        }

        // Bullet block
        // Split ONLY once: bullet sentence + optional trailing paragraph
        const match = part.match(
            /^(\d+(?:\.\d+)?[Kk]?\+?.*?)(?:\.\s+(.*))?$/
        );

        if (!match) return;

        const bulletText = match[1].trim();
        const trailingText = match[2]?.trim();

        bullets.push(bulletText.endsWith(".") ? bulletText : bulletText + ".");

        if (trailingText) {
            postBulletParagraphs.push(
                trailingText.endsWith(".") ? trailingText : trailingText + "."
            );
        }
    });

    let html = "";

    // Paragraphs before bullets
    paragraphs.forEach(p => {
        html += `<p>${p}</p>`;
    });

    // Bullets
    if (bullets.length) {
        html += `<ul>`;
        bullets.forEach(b => {
            html += `<li>${b}</li>`;
        });
        html += `</ul>`;
    }

    // Paragraphs after bullets
    postBulletParagraphs.forEach(p => {
        html += `<p>${p}</p>`;
    });

    return html;
}

// Fetch Google Sheet Data
fetch(url)
    .then((res) => res.text())
    .then((text) => {
        const json = JSON.parse(text.substring(47).slice(0, -2));

        sheetData = json.table.rows.map((r) => ({
            name: getText(r.c[1]),
            club: getText(r.c[2]),
            city: getText(r.c[3]),
            phone: getText(r.c[4]),
            logo: getText(r.c[5]),
            email: getText(r.c[6]),

            instaText: getText(r.c[7]),
            instaLink: getText(r.c[8]),

            info: getText(r.c[9]),
            whatsappLink: getText(r.c[10]),
            thumb: getText(r.c[11])
        }));

        populateCities();
    })
    .catch((err) => console.error("Google Sheet fetch failed:", err));

// Populate City Dropdown
function populateCities() {
    const cities = [...new Set(sheetData.map((i) => i.city).filter(Boolean))];

    citySelect.innerHTML = `<option value="">Select City</option>`;
    clubSelect.innerHTML = `<option value="">Select Club</option>`;
    clubSelect.disabled = true;
    hideResult();

    cities.forEach((city) => {
        citySelect.insertAdjacentHTML(
            "beforeend",
            `<option value="${city}">${city}</option>`
        );
    });
}

// Event Listeners
citySelect.addEventListener("change", (e) => {
    const city = e.target.value;

    clubSelect.innerHTML = `<option value="">Select Club</option>`;
    clubSelect.disabled = true;

    if (!city) return;

    sheetData
        .filter((i) => i.city === city)
        .forEach((i) => {
            clubSelect.insertAdjacentHTML(
                "beforeend",
                `<option value="${i.club}" data-name="${i.name}">
          ${i.club}
        </option>`
            );
        });

    clubSelect.disabled = false;
});

// Club Selection
clubSelect.addEventListener("change", (e) => {
    const clubName = e.target.value;
    if (!clubName) return;

    const selectedCity = citySelect.value;
    const selectedName = e.target.selectedOptions[0]?.dataset?.name || "";

    const matches = sheetData.filter(
        (i) => i.city === selectedCity && i.club === clubName
    );

    let item = null;

    if (matches.length === 1) {
        item = matches[0];
    } else if (matches.length > 1) {
        item = matches.find((m) => m.name === selectedName) || matches[0];
    }

    if (!item) return;

    resultEl.classList.remove("is-visible");
    requestAnimationFrame(() => resultEl.classList.add("is-visible"));
    showResult();

    /* Logo */
    const logoEl = document.getElementById("clubLogo");
    logoEl.src = item.logo || "";
    logoEl.alt = item.club || "Club Logo";

    // Thumbnail Logo
    const thumbWrap = document.querySelector(".club-thumb");
    const thumbEl = document.getElementById("clubThumb");

    if (item.thumb) {
        thumbEl.src = item.thumb;
        thumbWrap.style.display = "block";
    } else {
        thumbEl.src = "";
        thumbWrap.style.display = "none";
    }

    /* Main text */
    safeText(document.getElementById("clubName"), item.club, "Club Name");
    const infoEl = document.getElementById("clubInfo");
    infoEl.innerHTML = formatDescription(item.info);

    safeText(
        document.getElementById("contactName"),
        item.name,
        "Name not available"
    );
    safeText(
        document.getElementById("clubCity"),
        item.city,
        "City not available"
    );

    safeText(
        document.getElementById("clubPhone"),
        formatIndianPhone(item.phone),
        "Contact not available"
    );

    /* Email */
    const emailEl = document.getElementById("clubEmail");
    safeText(emailEl, item.email, "Email not available");
    emailEl.removeAttribute("href");

    /* Instagram */
    const instaEl = document.getElementById("clubInsta");

    if (item.instaLink) {
        instaEl.innerText = item.instaText || "Instagram";
        instaEl.href = item.instaLink;
        instaEl.target = "_blank";
        instaEl.rel = "noopener noreferrer";
        instaEl.style.pointerEvents = "auto";
        instaEl.style.cursor = "pointer";
    } else {
        instaEl.innerText = "Instagram not available";
        instaEl.removeAttribute("href");
        instaEl.style.pointerEvents = "none";
        instaEl.style.cursor = "not-allowed";
    }

    /* Join Button (WhatsApp) */
    const joinBtnText = joinBtn.querySelector(".join-btn__text");
    const joinBtnIcon = joinBtn.querySelector(".join-btn__icon");

    if (item.whatsappLink) {
        joinBtnText.innerText = "Join the club";
        joinBtn.href = item.whatsappLink;
        joinBtn.target = "_blank";
        joinBtn.style.pointerEvents = "auto";
        joinBtn.style.opacity = "1";
        joinBtn.style.cursor = "pointer";
        joinBtnIcon.style.display = "inline-flex";
    } else {
        joinBtnText.innerText = "WhatsApp link coming soon";
        joinBtn.removeAttribute("href");
        joinBtn.style.pointerEvents = "none";
        joinBtn.style.opacity = "0.6";
        joinBtn.style.cursor = "not-allowed";
        joinBtnIcon.style.display = "none";
    }
});

// Read More Custom Component
class ReadMore extends HTMLElement {
    connectedCallback() {
        this.text = this.querySelector(".block_description_text");
        this.toggle = this.querySelector(".read_more_inline");
        this.expanded = false;

        if (!this.text || !this.toggle) return;

        this.toggle.addEventListener("click", () => this.toggleContent());

        this.init();
        this.observeChanges();
    }

    init() {
        const styles = getComputedStyle(this.text);
        const lineHeight = parseFloat(styles.lineHeight);

        // Reset height to measure actual content
        this.text.style.maxHeight = "none";
        this.text.style.overflow = "visible";

        const fullHeight = this.text.scrollHeight;
        const lines = Math.round(fullHeight / lineHeight);

        // Collapse to exactly 2 lines
        this.collapsedHeight = lineHeight * 2;

        this.text.style.overflow = "hidden";
        this.text.style.maxHeight = this.collapsedHeight + "px";

        requestAnimationFrame(() => {
            // Show Read More ONLY if content exceeds 2 real lines
            if (lines <= 2) {
                this.toggle.style.display = "none";
            } else {
                this.toggle.style.display = "inline";
            }
        });
    }

    observeChanges() {
        this.observer = new MutationObserver(() => {
            this.expanded = false;
            this.toggle.textContent = "Read more";
            this.init();
        });

        this.observer.observe(this.text, {
            childList: true,
            characterData: true,
            subtree: true,
        });
    }

    toggleContent() {
        this.expanded = !this.expanded;
        this.classList.toggle("expanded", this.expanded);

        if (this.expanded) {
            this.text.style.maxHeight = this.text.scrollHeight + "px";
            this.toggle.textContent = "Read less";
        } else {
            this.text.style.maxHeight = this.collapsedHeight + "px";
            this.toggle.textContent = "Read more";
        }
    }
}

if (!customElements.get("read-more")) {
    customElements.define("read-more", ReadMore);
}